export const NetworkIcons = {
  Setting: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <path
          id="settings_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M129.092-844.945a1.087,1.087,0,0,1-.72-.248,1.069,1.069,0,0,1-.372-.645l-.372-1.935a8.987,8.987,0,0,1-1.1-.521,6.393,6.393,0,0,1-1-.695l-1.861.645a1.133,1.133,0,0,1-.757-.012,1.056,1.056,0,0,1-.583-.484l-.992-1.737a1.035,1.035,0,0,1-.124-.732,1.175,1.175,0,0,1,.372-.657l1.464-1.29q-.05-.3-.074-.6t-.025-.62q0-.323.025-.62t.074-.6l-1.464-1.29a1.176,1.176,0,0,1-.372-.657,1.035,1.035,0,0,1,.124-.732l.992-1.737a1.056,1.056,0,0,1,.583-.484,1.132,1.132,0,0,1,.757-.012l1.861.645a6.4,6.4,0,0,1,1-.695,8.978,8.978,0,0,1,1.1-.521l.372-1.935a1.069,1.069,0,0,1,.372-.645,1.087,1.087,0,0,1,.72-.248h1.985a1.087,1.087,0,0,1,.72.248,1.069,1.069,0,0,1,.372.645l.372,1.935a8.977,8.977,0,0,1,1.1.521,6.4,6.4,0,0,1,1,.695l1.861-.645a1.132,1.132,0,0,1,.757.012,1.056,1.056,0,0,1,.583.484l.992,1.737a1.035,1.035,0,0,1,.124.732,1.176,1.176,0,0,1-.372.657l-1.464,1.29q.05.3.074.6t.025.62q0,.323-.025.62t-.074.6l1.464,1.29a1.175,1.175,0,0,1,.372.657,1.035,1.035,0,0,1-.124.732l-.992,1.737a1.056,1.056,0,0,1-.583.484,1.133,1.133,0,0,1-.757.012l-1.861-.645a6.393,6.393,0,0,1-1,.695,8.986,8.986,0,0,1-1.1.521l-.372,1.935a1.069,1.069,0,0,1-.372.645,1.087,1.087,0,0,1-.72.248Zm.546-1.786h.893l.471-2.456a5.5,5.5,0,0,0,1.762-.645,5.166,5.166,0,0,0,1.414-1.191l2.382.794.447-.744-1.886-1.662a5.987,5.987,0,0,0,.236-.881,5.128,5.128,0,0,0,.087-.955,5.128,5.128,0,0,0-.087-.955,5.989,5.989,0,0,0-.236-.881l1.886-1.662-.447-.744-2.382.794a5.167,5.167,0,0,0-1.414-1.191,5.5,5.5,0,0,0-1.762-.645l-.471-2.456h-.893l-.471,2.456a5.5,5.5,0,0,0-1.762.645,5.167,5.167,0,0,0-1.414,1.191l-2.382-.794-.447.744,1.886,1.662a5.989,5.989,0,0,0-.236.881,5.13,5.13,0,0,0-.087.955,5.129,5.129,0,0,0,.087.955,5.987,5.987,0,0,0,.236.881l-1.886,1.662.447.744,2.382-.794a5.166,5.166,0,0,0,1.414,1.191,5.5,5.5,0,0,0,1.762.645Zm.447-4.168a3.446,3.446,0,0,0,2.531-1.042,3.446,3.446,0,0,0,1.042-2.531A3.446,3.446,0,0,0,132.615-857a3.446,3.446,0,0,0-2.531-1.042A3.446,3.446,0,0,0,127.554-857a3.446,3.446,0,0,0-1.042,2.531,3.446,3.446,0,0,0,1.042,2.531A3.446,3.446,0,0,0,130.085-850.9ZM130.085-854.472Z"
          transform="translate(-118.084 866.472)"
          fill="var(--locobuzz-primary-text-color)"
        />
      </g>
    </svg>
  ),
  Refresh: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <path
          id="refresh_20dp_5F6368_FILL0_wght400_GRAD0_opsz20_1_"
          data-name="refresh_20dp_5F6368_FILL0_wght400_GRAD0_opsz20 (1)"
          d="M201.1-749.81a8.771,8.771,0,0,1-6.442-2.653A8.771,8.771,0,0,1,192-758.9a8.771,8.771,0,0,1,2.653-6.442A8.771,8.771,0,0,1,201.1-768a8.582,8.582,0,0,1,3.805.853,9.623,9.623,0,0,1,3.016,2.274v-1.99a1.1,1.1,0,0,1,.325-.81,1.09,1.09,0,0,1,.805-.327,1.113,1.113,0,0,1,.812.327,1.092,1.092,0,0,1,.332.81v5.306a1.1,1.1,0,0,1-.327.81,1.1,1.1,0,0,1-.81.327h-5.306a1.1,1.1,0,0,1-.81-.325,1.09,1.09,0,0,1-.327-.805,1.112,1.112,0,0,1,.327-.812,1.092,1.092,0,0,1,.81-.332h3a6.727,6.727,0,0,0-2.4-2.211,6.607,6.607,0,0,0-3.253-.821,6.578,6.578,0,0,0-4.832,1.99,6.578,6.578,0,0,0-1.99,4.832,6.578,6.578,0,0,0,1.99,4.832,6.578,6.578,0,0,0,4.832,1.99,6.49,6.49,0,0,0,4.169-1.437,6.682,6.682,0,0,0,2.369-3.616,1.189,1.189,0,0,1,.521-.695,1.2,1.2,0,0,1,.838-.189,1.11,1.11,0,0,1,.757.426.933.933,0,0,1,.189.805,8.978,8.978,0,0,1-3.158,5.006A8.75,8.75,0,0,1,201.1-749.81Z"
          transform="translate(-189.095 770.905)"
          fill="var(--locobuzz-primary-text-color)"
        />
      </g>
    </svg>
  ),
  ZoomIn: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="icons_Q2"
          data-name="icons Q2"
          transform="translate(-1.284 -1.284)"
        >
          <g
            id="Group_75067"
            data-name="Group 75067"
            transform="translate(4 4)"
          >
            <path
              id="Path_73709"
              data-name="Path 73709"
              d="M17.568,14.32H16.176V12.928a.928.928,0,1,0-1.856,0V14.32H12.928a.928.928,0,1,0,0,1.856H14.32v1.392a.928.928,0,0,0,1.856,0V16.176h1.392a.928.928,0,0,0,0-1.856Z"
              transform="translate(-8.288 -8.288)"
              fill="var(--locobuzz-primary-text-color)"
            />
            <path
              id="Path_73710"
              data-name="Path 73710"
              d="M22.283,20.983l-5.8-5.8a6.983,6.983,0,1,0-1.3,1.3l5.8,5.8a.919.919,0,1,0,1.3-1.3ZM10.96,16.065a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,10.96,16.065Z"
              transform="translate(-4 -4)"
              fill="var(--locobuzz-primary-text-color)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  ZoomOut: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="icons_Q2"
          data-name="icons Q2"
          transform="translate(-1.284 -1.284)"
        >
          <g
            id="Group_75068"
            data-name="Group 75068"
            transform="translate(4 4)"
          >
            <path
              id="Path_73711"
              data-name="Path 73711"
              d="M17.568,17h-4.64a.928.928,0,1,0,0,1.856h4.64a.928.928,0,1,0,0-1.856Z"
              transform="translate(-8.288 -10.968)"
              fill="var(--locobuzz-primary-text-color)"
            />
            <path
              id="Path_73712"
              data-name="Path 73712"
              d="M22.283,20.983l-5.8-5.8a6.983,6.983,0,1,0-1.3,1.3l5.8,5.8a.919.919,0,1,0,1.3-1.3ZM10.96,16.065a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,10.96,16.065Z"
              transform="translate(-4 -4)"
              fill="var(--locobuzz-primary-text-color)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  ArrowUp: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g id="Q3_icons" data-name="Q3 icons" transform="translate(3.34 2.716)">
          <path
            id="Path_73708"
            data-name="Path 73708"
            d="M10.372,16.742,17.8,9.381a1.175,1.175,0,0,1,1.732,0l7.424,7.362a1.3,1.3,0,0,1,.124,1.67,1.175,1.175,0,0,1-1.856.124l-5.32-5.32V26.331a1.237,1.237,0,0,1-2.475,0V13.216l-5.32,5.32a1.175,1.175,0,0,1-1.856-.124A1.3,1.3,0,0,1,10.372,16.742Z"
            transform="translate(-10.001 -9)"
            fill="var(--locobuzz-primary-text-color)"
          />
        </g>
      </g>
    </svg>
  ),
  ArrowLeft: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="Q3_icons"
          data-name="Q3 icons"
          transform="translate(30.284 -6.661) rotate(90)"
        >
          <path
            id="Path_73708"
            data-name="Path 73708"
            d="M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z"
            fill="var(--locobuzz-primary-text-color)"
          />
        </g>
      </g>
    </svg>
  ),
  ArrowDown: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="Q3_icons"
          data-name="Q3 icons"
          transform="translate(-6.661 -6.284)"
        >
          <path
            id="Path_73708"
            data-name="Path 73708"
            d="M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z"
            fill="var(--locobuzz-primary-text-color)"
          />
        </g>
      </g>
    </svg>
  ),
  ArrowRight: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="Q3_icons"
          data-name="Q3 icons"
          transform="translate(-6.284 30.661) rotate(-90)"
        >
          <path
            id="Path_73708"
            data-name="Path 73708"
            d="M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z"
            fill="var(--locobuzz-primary-text-color)"
          />
        </g>
      </g>
    </svg>
  ),
  UnhideNodes: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <path
          id="visibility_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M69.222-756.928a3.934,3.934,0,0,0,2.889-1.19,3.934,3.934,0,0,0,1.19-2.889,3.934,3.934,0,0,0-1.19-2.889,3.934,3.934,0,0,0-2.889-1.19,3.934,3.934,0,0,0-2.889,1.19,3.934,3.934,0,0,0-1.19,2.889,3.934,3.934,0,0,0,1.19,2.889A3.934,3.934,0,0,0,69.222-756.928Zm0-1.748a2.248,2.248,0,0,1-1.651-.68,2.248,2.248,0,0,1-.68-1.651,2.248,2.248,0,0,1,.68-1.651,2.248,2.248,0,0,1,1.651-.68,2.248,2.248,0,0,1,1.651.68,2.248,2.248,0,0,1,.68,1.651,2.248,2.248,0,0,1-.68,1.651A2.248,2.248,0,0,1,69.222-758.676Zm0,4.662a10.58,10.58,0,0,1-5.8-1.687,12.4,12.4,0,0,1-4.2-4.456,1.317,1.317,0,0,1-.17-.407A1.959,1.959,0,0,1,59-761a2.034,2.034,0,0,1,.049-.443,1.31,1.31,0,0,1,.17-.413,12.4,12.4,0,0,1,4.2-4.456,10.58,10.58,0,0,1,5.8-1.687,10.58,10.58,0,0,1,5.8,1.688,12.4,12.4,0,0,1,4.2,4.456,1.316,1.316,0,0,1,.17.407,1.959,1.959,0,0,1,.049.437,2.034,2.034,0,0,1-.049.443,1.31,1.31,0,0,1-.17.413,12.4,12.4,0,0,1-4.2,4.456A10.58,10.58,0,0,1,69.222-754.014ZM69.222-761.007Zm0,5.245a9.467,9.467,0,0,0,5.026-1.408,9.423,9.423,0,0,0,3.545-3.836,9.422,9.422,0,0,0-3.545-3.836,9.466,9.466,0,0,0-5.026-1.408,9.466,9.466,0,0,0-5.026,1.408,9.422,9.422,0,0,0-3.545,3.836,9.423,9.423,0,0,0,3.545,3.836A9.467,9.467,0,0,0,69.222-755.763Z"
          transform="translate(-57.222 773.007)"
          fill="var(--locobuzz-primary-text-color)"
        />
      </g>
    </svg>
  ),
  HideNodes: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <path
          id="visibility_off_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
          d="M70.409-800.275a3.765,3.765,0,0,1,.78,1.158,4.106,4.106,0,0,1,.344,1.411.789.789,0,0,1-.245.585.8.8,0,0,1-.58.241.83.83,0,0,1-.6-.241.786.786,0,0,1-.247-.585,1.835,1.835,0,0,0-.1-.849,1.993,1.993,0,0,0-.424-.677,1.7,1.7,0,0,0-.654-.424,1.877,1.877,0,0,0-.837-.092.789.789,0,0,1-.585-.245.8.8,0,0,1-.241-.58.8.8,0,0,1,.241-.585.8.8,0,0,1,.585-.241,4.165,4.165,0,0,1,1.4.333A3.722,3.722,0,0,1,70.409-800.275ZM67.68-802.5q-.383,0-.745.024a6.672,6.672,0,0,0-.725.088,1.018,1.018,0,0,1-.652-.124.8.8,0,0,1-.4-.5.793.793,0,0,1,.08-.631.681.681,0,0,1,.511-.35,9.437,9.437,0,0,1,.965-.12q.478-.035.967-.034a10.667,10.667,0,0,1,5.654,1.571,10.114,10.114,0,0,1,3.914,4.327,1.444,1.444,0,0,1,.123.353,1.811,1.811,0,0,1,.034.355,1.81,1.81,0,0,1-.034.355,2.288,2.288,0,0,1-.1.356,8.327,8.327,0,0,1-1.006,1.627,12.881,12.881,0,0,1-1.31,1.424.76.76,0,0,1-.585.206.776.776,0,0,1-.562-.3.8.8,0,0,1-.195-.608.944.944,0,0,1,.287-.581,7.8,7.8,0,0,0,1.063-1.147,8.275,8.275,0,0,0,.818-1.33,8.469,8.469,0,0,0-3.315-3.636A9.1,9.1,0,0,0,67.68-802.5Zm0,11.561a10.146,10.146,0,0,1-5.528-1.594,11.407,11.407,0,0,1-3.97-4.236,1.033,1.033,0,0,1-.147-.375,2.313,2.313,0,0,1-.034-.4,2.3,2.3,0,0,1,.034-.4,1.058,1.058,0,0,1,.149-.378,11.687,11.687,0,0,1,1.233-1.926,10.374,10.374,0,0,1,1.611-1.629l-1.72-1.72a.79.79,0,0,1-.252-.573.79.79,0,0,1,.252-.573.8.8,0,0,1,.585-.252.8.8,0,0,1,.585.252l14.405,14.405a.79.79,0,0,1,.252.573.79.79,0,0,1-.252.573.8.8,0,0,1-.585.252.8.8,0,0,1-.585-.252L71.3-791.581a10.61,10.61,0,0,1-1.787.482A10.508,10.508,0,0,1,67.68-790.939ZM62.2-800.688a12.378,12.378,0,0,0-1.491,1.411,6.747,6.747,0,0,0-1.124,1.732,8.47,8.47,0,0,0,3.315,3.636,9.1,9.1,0,0,0,4.783,1.319,8.408,8.408,0,0,0,1.172-.08q.571-.08,1.145-.218l-1.032-1.032a4.005,4.005,0,0,1-.642.172,3.649,3.649,0,0,1-.642.057,3.716,3.716,0,0,1-2.73-1.124,3.716,3.716,0,0,1-1.124-2.73,2.639,2.639,0,0,1,.08-.642q.08-.321.149-.642ZM68.781-798.646ZM66.579-796.444Z"
          transform="translate(-55.703 809)"
          fill="var(--locobuzz-primary-text-color)"
        />
      </g>
    </svg>
  ),
  UnhideMultilne: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="Group_75094"
          data-name="Group 75094"
          transform="translate(-14437.385 4977.127)"
        >
          <line
            id="Line_9576"
            data-name="Line 9576"
            y1="10.019"
            x2="6.936"
            transform="translate(14442.239 -4972.532)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <line
            id="Line_9574"
            data-name="Line 9574"
            x2="6.165"
            y2="10.019"
            transform="translate(14449.946 -4970.991)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <path
            id="Path_73725"
            data-name="Path 73725"
            d="M14386.637-4957.472c-.395,8.036,6.257,9.7,6.257,9.7"
            transform="translate(62.814 -12.585)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <path
            id="Path_73726"
            data-name="Path 73726"
            d="M6.11,0C6.5,8.3,0,10.014,0,10.014"
            transform="translate(14447.886 -4965.438) rotate(-65)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <circle
            id="Ellipse_6647"
            data-name="Ellipse 6647"
            cx="2.996"
            cy="2.996"
            r="2.996"
            transform="translate(14446.389 -4976)"
            fill="var(--locobuzz-primary-text-color)"
          />
          <line
            id="Line_9575"
            data-name="Line 9575"
            x2="11.56"
            y2="1.541"
            transform="translate(14443.78 -4960.201)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <path
            id="Path_73727"
            data-name="Path 73727"
            d="M1.643,0C-3.263,7.167,4.381,11.706,4.381,11.706"
            transform="translate(14442.844 -4958.449) rotate(-69)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <circle
            id="Ellipse_6646"
            data-name="Ellipse 6646"
            cx="2.996"
            cy="2.996"
            r="2.996"
            transform="translate(14454.778 -4961.619)"
            fill="var(--locobuzz-primary-text-color)"
          />
          <circle
            id="Ellipse_6648"
            data-name="Ellipse 6648"
            cx="2.996"
            cy="2.996"
            r="2.996"
            transform="translate(14438 -4964.016)"
            fill="var(--locobuzz-primary-text-color)"
          />
        </g>
      </g>
    </svg>
  ),
  HideMultilne: (
    <svg
      id="Navigation"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_157145"
        data-name="Rectangle 157145"
        width="32"
        height="32"
        rx="6.7"
        transform="translate(32) rotate(90)"
        fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(4 4)">
        <g id="invisible_box" data-name="invisible box">
          <rect
            id="Rectangle_157085"
            data-name="Rectangle 157085"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g
          id="Group_75095"
          data-name="Group 75095"
          transform="translate(-14437.385 4977.813)"
        >
          <line
            id="Line_9576"
            data-name="Line 9576"
            y1="10.019"
            x2="6.936"
            transform="translate(14442.239 -4972.532)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.5"
          />
          <line
            id="Line_9574"
            data-name="Line 9574"
            x2="6.165"
            y2="10.019"
            transform="translate(14449.946 -4970.991)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="1"
          />
          <circle
            id="Ellipse_6647"
            data-name="Ellipse 6647"
            cx="2.996"
            cy="2.996"
            r="2.996"
            transform="translate(14446.389 -4976)"
            fill="var(--locobuzz-primary-text-color)"
          />
          <line
            id="Line_9575"
            data-name="Line 9575"
            x2="11.56"
            y2="1.541"
            transform="translate(14443.78 -4960.201)"
            fill="none"
            stroke="var(--locobuzz-primary-text-color)"
            stroke-linecap="round"
            stroke-width="0.7"
          />
          <circle
            id="Ellipse_6646"
            data-name="Ellipse 6646"
            cx="2.996"
            cy="2.996"
            r="2.996"
            transform="translate(14454.778 -4961.619)"
            fill="var(--locobuzz-primary-text-color)"
          />
          <circle
            id="Ellipse_6648"
            data-name="Ellipse 6648"
            cx="2.996"
            cy="2.996"
            r="2.996"
            transform="translate(14438 -4964.016)"
            fill="var(--locobuzz-primary-text-color)"
          />
        </g>
      </g>
    </svg>
  ),
};

// Helper function to get dimensions and transform based on isPersonalized
const getIconDimensions = (isPersonalized = false) => {
  return isPersonalized
    ? {
        size: 25,
        viewBox: "0 0 25 25",
        rx: "5.2", // proportional to 25x25
        transform: "translate(3.5 3.5) scale(0.75)", // better centering for 25x25
        rectTransform: "translate(25) rotate(90)",
        contentSize: "18", // adjusted content area for better fit
      }
    : {
        size: 32,
        viewBox: "0 0 32 32",
        rx: "6.7",
        transform: "translate(4 4)",
        rectTransform: "translate(32) rotate(90)",
        contentSize: "24", // content area size
      };
};

export const getNetworkIcon = (status = null, isPersonalized = false) => {
  const dims = getIconDimensions(isPersonalized);

  switch (status) {
    case "Setting":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color, var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width={dims.contentSize}
                height={dims.contentSize}
                fill="none"
              />
            </g>
            <path
              id="settings_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
              d="M129.092-844.945a1.087,1.087,0,0,1-.72-.248,1.069,1.069,0,0,1-.372-.645l-.372-1.935a8.987,8.987,0,0,1-1.1-.521,6.393,6.393,0,0,1-1-.695l-1.861.645a1.133,1.133,0,0,1-.757-.012,1.056,1.056,0,0,1-.583-.484l-.992-1.737a1.035,1.035,0,0,1-.124-.732,1.175,1.175,0,0,1,.372-.657l1.464-1.29q-.05-.3-.074-.6t-.025-.62q0-.323.025-.62t.074-.6l-1.464-1.29a1.176,1.176,0,0,1-.372-.657,1.035,1.035,0,0,1,.124-.732l.992-1.737a1.056,1.056,0,0,1,.583-.484,1.132,1.132,0,0,1,.757-.012l1.861.645a6.4,6.4,0,0,1,1-.695,8.978,8.978,0,0,1,1.1-.521l.372-1.935a1.069,1.069,0,0,1,.372-.645,1.087,1.087,0,0,1,.72-.248h1.985a1.087,1.087,0,0,1,.72.248,1.069,1.069,0,0,1,.372.645l.372,1.935a8.977,8.977,0,0,1,1.1.521,6.4,6.4,0,0,1,1,.695l1.861-.645a1.132,1.132,0,0,1,.757.012,1.056,1.056,0,0,1,.583.484l.992,1.737a1.035,1.035,0,0,1,.124.732,1.176,1.176,0,0,1-.372.657l-1.464,1.29q.05.3.074.6t.025.62q0,.323-.025.62t-.074.6l1.464,1.29a1.175,1.175,0,0,1,.372.657,1.035,1.035,0,0,1-.124.732l-.992,1.737a1.056,1.056,0,0,1-.583.484,1.133,1.133,0,0,1-.757.012l-1.861-.645a6.393,6.393,0,0,1-1,.695,8.986,8.986,0,0,1-1.1.521l-.372,1.935a1.069,1.069,0,0,1-.372.645,1.087,1.087,0,0,1-.72.248Zm.546-1.786h.893l.471-2.456a5.5,5.5,0,0,0,1.762-.645,5.166,5.166,0,0,0,1.414-1.191l2.382.794.447-.744-1.886-1.662a5.987,5.987,0,0,0,.236-.881,5.128,5.128,0,0,0,.087-.955,5.128,5.128,0,0,0-.087-.955,5.989,5.989,0,0,0-.236-.881l1.886-1.662-.447-.744-2.382.794a5.167,5.167,0,0,0-1.414-1.191,5.5,5.5,0,0,0-1.762-.645l-.471-2.456h-.893l-.471,2.456a5.5,5.5,0,0,0-1.762.645,5.167,5.167,0,0,0-1.414,1.191l-2.382-.794-.447.744,1.886,1.662a5.989,5.989,0,0,0-.236.881,5.13,5.13,0,0,0-.087.955,5.129,5.129,0,0,0,.087.955,5.987,5.987,0,0,0,.236.881l-1.886,1.662.447.744,2.382-.794a5.166,5.166,0,0,0,1.414,1.191,5.5,5.5,0,0,0,1.762.645Zm.447-4.168a3.446,3.446,0,0,0,2.531-1.042,3.446,3.446,0,0,0,1.042-2.531A3.446,3.446,0,0,0,132.615-857a3.446,3.446,0,0,0-2.531-1.042A3.446,3.446,0,0,0,127.554-857a3.446,3.446,0,0,0-1.042,2.531,3.446,3.446,0,0,0,1.042,2.531A3.446,3.446,0,0,0,130.085-850.9ZM130.085-854.472Z"
              transform="translate(-118.084 866.472)"
              fill="var(--locobuzz-primary-text-color)"
            />
          </g>
        </svg>
      );

    case "Refresh":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color, var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width={dims.contentSize}
                height={dims.contentSize}
                fill="none"
              />
            </g>
            <path
              id="refresh_20dp_5F6368_FILL0_wght400_GRAD0_opsz20_1_"
              data-name="refresh_20dp_5F6368_FILL0_wght400_GRAD0_opsz20 (1)"
              d="M201.1-749.81a8.771,8.771,0,0,1-6.442-2.653A8.771,8.771,0,0,1,192-758.9a8.771,8.771,0,0,1,2.653-6.442A8.771,8.771,0,0,1,201.1-768a8.582,8.582,0,0,1,3.805.853,9.623,9.623,0,0,1,3.016,2.274v-1.99a1.1,1.1,0,0,1,.325-.81,1.09,1.09,0,0,1,.805-.327,1.113,1.113,0,0,1,.812.327,1.092,1.092,0,0,1,.332.81v5.306a1.1,1.1,0,0,1-.327.81,1.1,1.1,0,0,1-.81.327h-5.306a1.1,1.1,0,0,1-.81-.325,1.09,1.09,0,0,1-.327-.805,1.112,1.112,0,0,1,.327-.812,1.092,1.092,0,0,1,.81-.332h3a6.727,6.727,0,0,0-2.4-2.211,6.607,6.607,0,0,0-3.253-.821,6.578,6.578,0,0,0-4.832,1.99,6.578,6.578,0,0,0-1.99,4.832,6.578,6.578,0,0,0,1.99,4.832,6.578,6.578,0,0,0,4.832,1.99,6.49,6.49,0,0,0,4.169-1.437,6.682,6.682,0,0,0,2.369-3.616,1.189,1.189,0,0,1,.521-.695,1.2,1.2,0,0,1,.838-.189,1.11,1.11,0,0,1,.757.426.933.933,0,0,1,.189.805,8.978,8.978,0,0,1-3.158,5.006A8.75,8.75,0,0,1,201.1-749.81Z"
              transform="translate(-189.095 770.905)"
              fill="var(--locobuzz-primary-text-color)"
            />
          </g>
        </svg>
      );

    case "ZoomIn":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color, var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width={dims.contentSize}
                height={dims.contentSize}
                fill="none"
              />
            </g>
            <g
              id="icons_Q2"
              data-name="icons Q2"
              transform="translate(-1.284 -1.284)"
            >
              <g
                id="Group_75067"
                data-name="Group 75067"
                transform="translate(4 4)"
              >
                <path
                  id="Path_73709"
                  data-name="Path 73709"
                  d="M17.568,14.32H16.176V12.928a.928.928,0,1,0-1.856,0V14.32H12.928a.928.928,0,1,0,0,1.856H14.32v1.392a.928.928,0,0,0,1.856,0V16.176h1.392a.928.928,0,0,0,0-1.856Z"
                  transform="translate(-8.288 -8.288)"
                  fill="var(--locobuzz-primary-text-color)"
                />
                <path
                  id="Path_73710"
                  data-name="Path 73710"
                  d="M22.283,20.983l-5.8-5.8a6.983,6.983,0,1,0-1.3,1.3l5.8,5.8a.919.919,0,1,0,1.3-1.3ZM10.96,16.065a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,10.96,16.065Z"
                  transform="translate(-4 -4)"
                  fill="var(--locobuzz-primary-text-color)"
                />
              </g>
            </g>
          </g>
        </svg>
      );

    case "ZoomOut":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color, var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="icons_Q2"
              data-name="icons Q2"
              transform="translate(-1.284 -1.284)"
            >
              <g
                id="Group_75068"
                data-name="Group 75068"
                transform="translate(4 4)"
              >
                <path
                  id="Path_73711"
                  data-name="Path 73711"
                  d="M17.568,17h-4.64a.928.928,0,1,0,0,1.856h4.64a.928.928,0,1,0,0-1.856Z"
                  transform="translate(-8.288 -10.968)"
                  fill="var(--locobuzz-primary-text-color)"
                />
                <path
                  id="Path_73712"
                  data-name="Path 73712"
                  d="M22.283,20.983l-5.8-5.8a6.983,6.983,0,1,0-1.3,1.3l5.8,5.8a.919.919,0,1,0,1.3-1.3ZM10.96,16.065a5.1,5.1,0,1,1,5.1-5.1A5.1,5.1,0,0,1,10.96,16.065Z"
                  transform="translate(-4 -4)"
                  fill="var(--locobuzz-primary-text-color)"
                />
              </g>
            </g>
          </g>
        </svg>
      );

    case "ArrowUp":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color, var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="Q3_icons"
              data-name="Q3 icons"
              transform="translate(3.34 2.716)"
            >
              <path
                id="Path_73708"
                data-name="Path 73708"
                d="M10.372,16.742,17.8,9.381a1.175,1.175,0,0,1,1.732,0l7.424,7.362a1.3,1.3,0,0,1,.124,1.67,1.175,1.175,0,0,1-1.856.124l-5.32-5.32V26.331a1.237,1.237,0,0,1-2.475,0V13.216l-5.32,5.32a1.175,1.175,0,0,1-1.856-.124A1.3,1.3,0,0,1,10.372,16.742Z"
                transform="translate(-10.001 -9)"
                fill="var(--locobuzz-primary-text-color)"
              />
            </g>
          </g>
        </svg>
      );

    case "ArrowDown":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color, var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="Q3_icons"
              data-name="Q3 icons"
              transform="translate(-6.661 -6.284)"
            >
              <path
                id="Path_73708"
                data-name="Path 73708"
                d="M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z"
                fill="var(--locobuzz-primary-text-color)"
              />
            </g>
          </g>
        </svg>
      );

    case "ArrowLeft":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="Q3_icons"
              data-name="Q3 icons"
              transform="translate(30.284 -6.661) rotate(90)"
            >
              <path
                id="Path_73708"
                data-name="Path 73708"
                d="M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z"
                fill="var(--locobuzz-primary-text-color)"
              />
            </g>
          </g>
        </svg>
      );

    case "ArrowRight":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="Q3_icons"
              data-name="Q3 icons"
              transform="translate(-6.284 30.661) rotate(-90)"
            >
              <path
                id="Path_73708"
                data-name="Path 73708"
                d="M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z"
                fill="var(--locobuzz-primary-text-color)"
              />
            </g>
          </g>
        </svg>
      );

    case "UnhideNodes":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <path
              id="visibility_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
              d="M69.222-756.928a3.934,3.934,0,0,0,2.889-1.19,3.934,3.934,0,0,0,1.19-2.889,3.934,3.934,0,0,0-1.19-2.889,3.934,3.934,0,0,0-2.889-1.19,3.934,3.934,0,0,0-2.889,1.19,3.934,3.934,0,0,0-1.19,2.889,3.934,3.934,0,0,0,1.19,2.889A3.934,3.934,0,0,0,69.222-756.928Zm0-1.748a2.248,2.248,0,0,1-1.651-.68,2.248,2.248,0,0,1-.68-1.651,2.248,2.248,0,0,1,.68-1.651,2.248,2.248,0,0,1,1.651-.68,2.248,2.248,0,0,1,1.651.68,2.248,2.248,0,0,1,.68,1.651,2.248,2.248,0,0,1-.68,1.651A2.248,2.248,0,0,1,69.222-758.676Zm0,4.662a10.58,10.58,0,0,1-5.8-1.687,12.4,12.4,0,0,1-4.2-4.456,1.317,1.317,0,0,1-.17-.407A1.959,1.959,0,0,1,59-761a2.034,2.034,0,0,1,.049-.443,1.31,1.31,0,0,1,.17-.413,12.4,12.4,0,0,1,4.2-4.456,10.58,10.58,0,0,1,5.8-1.687,10.58,10.58,0,0,1,5.8,1.688,12.4,12.4,0,0,1,4.2,4.456,1.316,1.316,0,0,1,.17.407,1.959,1.959,0,0,1,.049.437,2.034,2.034,0,0,1-.049.443,1.31,1.31,0,0,1-.17.413,12.4,12.4,0,0,1-4.2,4.456A10.58,10.58,0,0,1,69.222-754.014ZM69.222-761.007Zm0,5.245a9.467,9.467,0,0,0,5.026-1.408,9.423,9.423,0,0,0,3.545-3.836,9.422,9.422,0,0,0-3.545-3.836,9.466,9.466,0,0,0-5.026-1.408,9.466,9.466,0,0,0-5.026,1.408,9.422,9.422,0,0,0-3.545,3.836,9.423,9.423,0,0,0,3.545,3.836A9.467,9.467,0,0,0,69.222-755.763Z"
              transform="translate(-57.222 773.007)"
              fill="var(--locobuzz-primary-text-color)"
            />
          </g>
        </svg>
      );

    case "HideNodes":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <path
              id="visibility_off_20dp_5F6368_FILL0_wght400_GRAD0_opsz20"
              d="M70.409-800.275a3.765,3.765,0,0,1,.78,1.158,4.106,4.106,0,0,1,.344,1.411.789.789,0,0,1-.245.585.8.8,0,0,1-.58.241.83.83,0,0,1-.6-.241.786.786,0,0,1-.247-.585,1.835,1.835,0,0,0-.1-.849,1.993,1.993,0,0,0-.424-.677,1.7,1.7,0,0,0-.654-.424,1.877,1.877,0,0,0-.837-.092.789.789,0,0,1-.585-.245.8.8,0,0,1-.241-.58.8.8,0,0,1,.241-.585.8.8,0,0,1,.585-.241,4.165,4.165,0,0,1,1.4.333A3.722,3.722,0,0,1,70.409-800.275ZM67.68-802.5q-.383,0-.745.024a6.672,6.672,0,0,0-.725.088,1.018,1.018,0,0,1-.652-.124.8.8,0,0,1-.4-.5.793.793,0,0,1,.08-.631.681.681,0,0,1,.511-.35,9.437,9.437,0,0,1,.965-.12q.478-.035.967-.034a10.667,10.667,0,0,1,5.654,1.571,10.114,10.114,0,0,1,3.914,4.327,1.444,1.444,0,0,1,.123.353,1.811,1.811,0,0,1,.034.355,1.81,1.81,0,0,1-.034.355,2.288,2.288,0,0,1-.1.356,8.327,8.327,0,0,1-1.006,1.627,12.881,12.881,0,0,1-1.31,1.424.76.76,0,0,1-.585.206.776.776,0,0,1-.562-.3.8.8,0,0,1-.195-.608.944.944,0,0,1,.287-.581,7.8,7.8,0,0,0,1.063-1.147,8.275,8.275,0,0,0,.818-1.33,8.469,8.469,0,0,0-3.315-3.636A9.1,9.1,0,0,0,67.68-802.5Zm0,11.561a10.146,10.146,0,0,1-5.528-1.594,11.407,11.407,0,0,1-3.97-4.236,1.033,1.033,0,0,1-.147-.375,2.313,2.313,0,0,1-.034-.4,2.3,2.3,0,0,1,.034-.4,1.058,1.058,0,0,1,.149-.378,11.687,11.687,0,0,1,1.233-1.926,10.374,10.374,0,0,1,1.611-1.629l-1.72-1.72a.79.79,0,0,1-.252-.573.79.79,0,0,1,.252-.573.8.8,0,0,1,.585-.252.8.8,0,0,1,.585.252l14.405,14.405a.79.79,0,0,1,.252.573.79.79,0,0,1-.252.573.8.8,0,0,1-.585.252.8.8,0,0,1-.585-.252L71.3-791.581a10.61,10.61,0,0,1-1.787.482A10.508,10.508,0,0,1,67.68-790.939ZM62.2-800.688a12.378,12.378,0,0,0-1.491,1.411,6.747,6.747,0,0,0-1.124,1.732,8.47,8.47,0,0,0,3.315,3.636,9.1,9.1,0,0,0,4.783,1.319,8.408,8.408,0,0,0,1.172-.08q.571-.08,1.145-.218l-1.032-1.032a4.005,4.005,0,0,1-.642.172,3.649,3.649,0,0,1-.642.057,3.716,3.716,0,0,1-2.73-1.124,3.716,3.716,0,0,1-1.124-2.73,2.639,2.639,0,0,1,.08-.642q.08-.321.149-.642ZM68.781-798.646ZM66.579-796.444Z"
              transform="translate(-55.703 809)"
              fill="var(--locobuzz-primary-text-color)"
            />
          </g>
        </svg>
      );

    case "UnhideMultilne":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="Group_75094"
              data-name="Group 75094"
              transform="translate(-14437.385 4977.127)"
            >
              <line
                id="Line_9576"
                data-name="Line 9576"
                y1="10.019"
                x2="6.936"
                transform="translate(14442.239 -4972.532)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <line
                id="Line_9574"
                data-name="Line 9574"
                x2="6.165"
                y2="10.019"
                transform="translate(14449.946 -4970.991)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <path
                id="Path_73725"
                data-name="Path 73725"
                d="M14386.637-4957.472c-.395,8.036,6.257,9.7,6.257,9.7"
                transform="translate(62.814 -12.585)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <path
                id="Path_73726"
                data-name="Path 73726"
                d="M6.11,0C6.5,8.3,0,10.014,0,10.014"
                transform="translate(14447.886 -4965.438) rotate(-65)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <circle
                id="Ellipse_6647"
                data-name="Ellipse 6647"
                cx="2.996"
                cy="2.996"
                r="2.996"
                transform="translate(14446.389 -4976)"
                fill="var(--locobuzz-primary-text-color)"
              />
              <line
                id="Line_9575"
                data-name="Line 9575"
                x2="11.56"
                y2="1.541"
                transform="translate(14443.78 -4960.201)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <path
                id="Path_73727"
                data-name="Path 73727"
                d="M1.643,0C-3.263,7.167,4.381,11.706,4.381,11.706"
                transform="translate(14442.844 -4958.449) rotate(-69)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <circle
                id="Ellipse_6646"
                data-name="Ellipse 6646"
                cx="2.996"
                cy="2.996"
                r="2.996"
                transform="translate(14454.778 -4961.619)"
                fill="var(--locobuzz-primary-text-color)"
              />
              <circle
                id="Ellipse_6648"
                data-name="Ellipse 6648"
                cx="2.996"
                cy="2.996"
                r="2.996"
                transform="translate(14438 -4964.016)"
                fill="var(--locobuzz-primary-text-color)"
              />
            </g>
          </g>
        </svg>
      );

    case "HideMultilne":
      return (
        <svg
          id="Navigation"
          xmlns="http://www.w3.org/2000/svg"
          width={dims.size}
          height={dims.size}
          viewBox={dims.viewBox}
        >
          <rect
            id="Rectangle_157145"
            data-name="Rectangle 157145"
            width={dims.size}
            height={dims.size}
            rx={dims.rx}
            transform={dims.rectTransform}
            fill="var(--locobuzz-cc-screen-container-bg-primary-color,var(--locobuzz-primary-bg-color))"
          />
          <g id="Layer_2" data-name="Layer 2" transform={dims.transform}>
            <g id="invisible_box" data-name="invisible box">
              <rect
                id="Rectangle_157085"
                data-name="Rectangle 157085"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g
              id="Group_75095"
              data-name="Group 75095"
              transform="translate(-14437.385 4977.813)"
            >
              <line
                id="Line_9576"
                data-name="Line 9576"
                y1="10.019"
                x2="6.936"
                transform="translate(14442.239 -4972.532)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.5"
              />
              <line
                id="Line_9574"
                data-name="Line 9574"
                x2="6.165"
                y2="10.019"
                transform="translate(14449.946 -4970.991)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_6647"
                data-name="Ellipse 6647"
                cx="2.996"
                cy="2.996"
                r="2.996"
                transform="translate(14446.389 -4976)"
                fill="var(--locobuzz-primary-text-color)"
              />
              <line
                id="Line_9575"
                data-name="Line 9575"
                x2="11.56"
                y2="1.541"
                transform="translate(14443.78 -4960.201)"
                fill="none"
                stroke="var(--locobuzz-primary-text-color)"
                strokeLinecap="round"
                strokeWidth="0.7"
              />
              <circle
                id="Ellipse_6646"
                data-name="Ellipse 6646"
                cx="2.996"
                cy="2.996"
                r="2.996"
                transform="translate(14454.778 -4961.619)"
                fill="var(--locobuzz-primary-text-color)"
              />
              <circle
                id="Ellipse_6648"
                data-name="Ellipse 6648"
                cx="2.996"
                cy="2.996"
                r="2.996"
                transform="translate(14438 -4964.016)"
                fill="var(--locobuzz-primary-text-color)"
              />
            </g>
          </g>
        </svg>
      );

    default:
      return "";
  }
};
